import React from 'react';

import {MainLayout} from 'widgets/layout';
import {listPageClassName} from 'shared/ui/ListPage/ListPage';
import {ServerIncidentsScreen} from 'features/server';

const ServerIncidentsPage: React.FC = () => {
    return (
        <MainLayout className={listPageClassName}>
            <ServerIncidentsScreen/>
        </MainLayout>
    );
};

export default ServerIncidentsPage;
